import {toggleLoader, setErrorInformation} from './application';
import { webConfig } from '../constants/web-config.js';
//import { redirectConfig } from '../constants/redirect-config.js';
import {AUTH_ENDPOINT, DEFAULT_PAGE, CA_SERVERS_ENDPOINT,
        CHALLENGE_ENDPOINT, REGISTER_ENDPOINT, ACTIVATE_ENDPOINT,
        RESTORE_PASSWORD_ENDPOINT, RESET_PASSWORD_ENDPOINT} from '../constants/app-constants';
import {userSelector} from "./user";
import {history} from '../App';

const _path = webConfig.apiUrl,
  contentTypes = {
    json: "application/json",
    html: "text/html"
  },
  errorTypes = {
    sessionBlocked: 101,
    sessionExpired: 105,
    needChangePassword: 112
  };

function isContentTypeComplies(current, compared) {
  return current.indexOf(compared) !== -1
}

function isAuthRequired(endpoint) {
  return [
    AUTH_ENDPOINT,
    CA_SERVERS_ENDPOINT,
    CHALLENGE_ENDPOINT,
    REGISTER_ENDPOINT,
    ACTIVATE_ENDPOINT,
    RESTORE_PASSWORD_ENDPOINT,
    RESET_PASSWORD_ENDPOINT
  ].indexOf(endpoint) == -1;
}

function isNoFetch(token, endpoint) {
  return !token && isAuthRequired(endpoint)
}

async function handleResponse(dispatch, response, res) {
  if (!response.ok) {
    throw (response);
  } else {
    const userId = response.headers.get("User-Identity") || '',
      contentType = response.headers.get("content-type") || '';
    /*if (userId) {
      //todo: но зачем?
      dispatch(setNewData(parseInt(userId), "userId"));
    }*/
      let _data;
      if(isContentTypeComplies(contentType, contentTypes.json)) {
        _data = await response.json();
      } else {
        _data = await response.blob();
      }
      dispatch(handlePayload(_data, res, response.headers));
    }
}

function showIncorrectResponseMessage(dispatch) {
  dispatch(setErrorInformation("Трапилась невідома помилка, некоректна відповідь сервера"))
}

const handlePayload = (data, response, headers) => {
  return dispatch => {
    dispatch(toggleLoader(false));
    response(data, headers);
  }
};

function refreshOnNewVersion(dispatch) {
  dispatch(setErrorInformation("Вийшла нова версія ПЗ, виконується оновлення сторінки…\n"
    + "Якщо це повідомлення буде повторюватись, зверніться до технічної підтримки."));
  setTimeout(() => { window.location.reload(true); }, 3000);
}

//-----------------------------FETCH--------------------------------
export const performFetch = (method, endpoint, res, rej, body, headers, isHideErrorInformationSnack = false) => {
  return async (dispatch, getState) => {
    if (!endpoint) {
      if (console && console.error)
        console.error('Непередбачена помилка, спроба звернутися за пустим посиланням. Тіло запиту: ', body);
      dispatch(setErrorInformation('Непередбачена помилка, спроба звернутися за пустим посиланням. Зверніться до підтримки зі скриншотом вкладки Console інструментів розробника, де розгорнуто останню помилку'));
      return rej();
    }
    dispatch(toggleLoader(true));
    const { token } = userSelector(getState());

    if (isNoFetch(token, endpoint))
      return handleNoFetch(dispatch)

    let _headers = {
      ...headers
    };

    // по дефолту мы всегда ожидаем джейсон
    if (!_headers['Content-Type'] && !(body && body instanceof FormData)) {
      _headers['Content-Type'] = contentTypes.json;
    }
    if (!_headers['Accept']) {
      _headers['Accept'] = contentTypes.json + ';q=0.9,*/*;q=0.8';
    }

    if (!_headers['Authorization'] && isAuthRequired(endpoint))
    // `Bearer ${JSON.parse(sessionStorage.getItem('Token')).access_token}`
      _headers['Authorization'] = `Bearer ${token && token.access_token}`;

    let _body = body;
    if (!_body) {
      _body = method === 'get' ? undefined : "{}"; // Request with GET/HEAD method cannot have body, а для обычных оставляю {} как изначально сделали ради пустых объектов
    }
    if (_body && !(
      (typeof _body === 'string') ||
      (_body instanceof FormData) ||
      (_body instanceof Blob) ||
      (_body instanceof ArrayBuffer) ||
      //(_body instanceof ArrayBufferView) ||
      (_body instanceof URLSearchParams)
    )) {
      _body = JSON.stringify(_body);
    };

    try {
      const response = await fetch(`${_path + endpoint}`, {
        mode: 'cors',
        method: method,
        headers: _headers,
        body: _body
      });
      await handleResponse(dispatch, response, res);
    }
    catch(errorResponse) {
      await handleError(dispatch, errorResponse, rej, isHideErrorInformationSnack);
    }
  };
};


async function handleError(dispatch, response, rej, isHideErrorInformationSnack) {

  dispatch(toggleLoader(false));
  let _data;
  try {
    // это случай без ответа от сервера или js-ошибок, видимо, оставляю как есть
    if (response.stack) {
      if (!isHideErrorInformationSnack) {
        if (response.message)
          dispatch(setErrorInformation(response.message));
        else
          dispatch(setErrorInformation("Не вдалось з'єднатись з сервером"));
      }
      rej(response);
      return;
    }
    if (!response.json) {
      if (!isHideErrorInformationSnack) showIncorrectResponseMessage(dispatch);
      return;
    }
    _data = await response.json();


    // 2833: токен по какой-то причине повреждён или признан сервером как невалидный
    if (response.status && response.status == 401
      && _data.message && _data.message === 'Authorization has been denied for this request.') {
      history.push(DEFAULT_PAGE)
      return;
    }
    if (response.status && response.status == 400
      && _data.error == "invalid_request" && _data.error_description == "Missing or invalid version parameter") {
      return refreshOnNewVersion(dispatch);
    }
    //todo: почему это было написано в catch? это рейзит response.json() или rej(data)?
    if (response.status && response.status == 413) {
      dispatch(setErrorInformation('413: Перевищено максимально допустимий розмір запиту. Можливо, ви намагаєтесь завантажити завеликий файл/файли'));
      return;
    }
    dispatch(handleClosedSession(_data));
    //dispatch(handleNeedChangePassword(_data));
    !isHideErrorInformationSnack && dispatch(setErrorInformation(_data.error || _data));
  } catch (error) {
    console.error(error);
    !isHideErrorInformationSnack && showIncorrectResponseMessage(dispatch);
  }
  rej(_data);
}

const handleClosedSession = (data) => {
  return dispatch => {
    if (data.errorCode === errorTypes.sessionBlocked
      || data.errorCode === errorTypes.sessionExpired)
      history.push(DEFAULT_PAGE);
  }
};

export const post = (endpoint, res, rej, body, headers, isHideErrorInformationSnack = false) => {
  return dispatch => {
    dispatch(performFetch('post', endpoint, res, rej, body, headers, isHideErrorInformationSnack));
  };
};

export const promisePostSimple = (endpoint, body, headers) => {
  return dispatch => {
    return new Promise((res, rej) => {
      dispatch(performFetch('post', endpoint, res, rej, body, headers));
    });
  };
};

//Отличие от promisePostSimple - резолвит промис с массивом, второй аргумент которого хидер запроса
export const promisePostSimpleWithHeaders = (endpoint, body, headers) => {
  return dispatch => {
    return new Promise((res, rej) => {
      dispatch(performFetch('post', endpoint, (data, headers) => res([data, headers]), rej, body, headers));
    });
  };
};

export const put = (endpoint, res, rej, body, headers) => {
  return dispatch => {
    dispatch(performFetch('put', endpoint, res, rej, body, headers));
  };
};

// reject промиса только вызывает проблемы, т.к. люди не catch()-ят
// постепенно переходить везде с метода request на этот (разве что вам в явном виде нужен reject)
// Закомментил, это вредная функа, т.к отсутствие реджекта промиса приводит к тому что final-form остается
// в вечном состоянии submitting и повторным сабмит формы после ошибки не проходит
/*export const requestEx = (endpoint, body, isHideErrorInformationSnack = false) => {
  return (dispatch) => {
    return new Promise(resolve => {
      dispatch(post(
        endpoint,
        (data) => { resolve(data) },
        (reason) => { console.log(reason); },
        JSON.stringify(body),
        null,
        isHideErrorInformationSnack
      ));
    });
  }
};*/

function handleNoFetch(dispatch) {
  dispatch(toggleLoader(false));
  history.push(DEFAULT_PAGE);
}